<template>
  <div v-html="gbl.content.partners"/>
</template>

<script>
  export default {
    name: 'PartnersPage',
    data() {
      return {
        gbl
      }
    }
  }
</script>


// WEBPACK FOOTER //
// resources/js/pages/PartnersPage.vue